import type { SystemStyleFunction } from "@chakra-ui/styled-system"

const variantSubtle: SystemStyleFunction = (props) => {
  let color
  let bg
  let rest = {}

  if (props.colorScheme === "primary") {
    color = "main.700"
    bg = "primary.50"
  }
  if (props.colorScheme === "black") {
    color = "neutrals.850"
    bg = "neutrals.50"
    rest = {
      boxShadow: "0 0 12px 5px var(--chakra-colors-blackAlpha-50)",
    }
  }
  if (props.colorScheme === "yellowBright") {
    color = "yellowBright.800"
    bg = "yellowBright.50"
  }
  if (props.colorScheme === "red") {
    color = "red.300"
    bg = "red.50"
  }

  return {
    color,
    bg,
    ...rest,
  }
}

const variantNaked: SystemStyleFunction = (props) => {
  return {
    ...variantSubtle(props),
    bg: "transparent",
    p: 0,
  }
}

export const Badge = {
  baseStyle: {
    borderRadius: "full",
    textTransform: "none",
    py: 0.5,
    px: 2,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1.5,
    textAlign: "center",
    width: "fit-content",
  },
  sizes: {
    sm: {
      fontSize: 8,
    },
    md: {
      fontSize: 11,
    },
    lg: {
      fontSize: 12,
    },
  },
  variants: {
    naked: variantNaked,
    subtle: variantSubtle,
  },
  defaultProps: {
    variant: "subtle",
  },
}
